module.exports = __webpack_public_path__ + "media/images/overdue-icon-4696936ca471306b6fd449473fd3c476.svg";